import script from "./productSetItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./productSetItems.vue?vue&type=script&lang=ts&setup=true"

import "./productSetItems.vue?vue&type=style&index=0&id=7eaecad3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eaecad3"]])

export default __exports__